import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './env';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storageKey: 'sb-session',
    autoRefreshToken: true,   // SDK가 만료 1분 전 자동 갱신 — 1시간 로그아웃 완전 해결
    persistSession: true,
    detectSessionInUrl: true,
  },
  global: {
    fetch: (url, options) => {
      const urlStr = url.toString();
      // Edge Function 타임아웃: invokeWithTimeout 최대값(100s)보다 크게 설정해
      // invokeWithTimeout이 먼저 발동해 user-friendly 메시지를 보여주도록 한다.
      // 60s였을 때: LLM(90s) 호출 중 먼저 abort → "Failed to send a request" 오류 표시.
      const ms = urlStr.includes('/functions/v1/')
        ? 120_000  // 2분 — invokeWithTimeout(최대 100s)보다 길어야 함
        : urlStr.includes('/auth/v1/')
        ? 60_000
        : 15_000;
      const ctrl = new AbortController();
      const id = setTimeout(() => ctrl.abort(), ms);
      // SDK 또는 호출자가 별도 signal을 전달한 경우 체인
      options?.signal?.addEventListener('abort', () => ctrl.abort(), { once: true });
      return fetch(url, { ...options, signal: ctrl.signal })
        .finally(() => clearTimeout(id));
    },
  },
});

export interface GalleryItemDB {
  id: string;
  type: 'image' | 'video';
  url: string;
  prompt: string;
  original_prompt?: string | null;
  model: string;
  ratio: string;
  liked: boolean;
  duration?: string | null;
  created_at: string;
  user_id: string;
  session_id?: string | null;
  source?: string | null;
}

export interface AutomationProjectDB {
  id: string;
  title: string;
  topic: string;
  status: 'completed' | 'generating' | 'draft' | 'failed';
  duration: number;
  ratio: string;
  style: string;
  thumbnail: string;
  video_url?: string | null;
  views: number;
  likes: number;
  model: string;
  mode: string;
  cuts: number;
  progress?: number | null;
  source?: string | null;
  step_data?: import('@/mocks/automationProjects').AutomationStepData | null;
  created_at: string;
  updated_at: string;
}

